







import Vue from 'vue';
export default Vue.extend({
  name: 'FooterLinkList',
  props: {
    heading: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      required: true,
    },
  },
});
